import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from './confirmation-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  constructor(private modalService: NgbModal) { }

  confirm(
    title: string = 'Confirm',
    message: string = 'Are you sure you want to proceed?',
    confirmButtonText: string = 'Ok',
    cancelButtonText: string = 'Cancel',
    isReversible: boolean = false,
    type: 'default' | 'danger' = 'default'
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.confirmButtonText = confirmButtonText;
    modalRef.componentInstance.cancelButtonText = cancelButtonText;
    modalRef.componentInstance.isReversible = isReversible;
    modalRef.componentInstance.type = type;

    return modalRef.result.catch(() => false); // Return false if dismissed
  }
}
